import yup, {
    cardNameValidator,
    imageValidator,
    arrayValidator,
    integerPositiveValidator,
} from '~/utils/validators.yup';

export const schema = (nullable = false) =>
    yup.object({
        name: cardNameValidator(),
        image: imageValidator(nullable),
        icon: imageValidator(nullable),
        statPoint: integerPositiveValidator,
        rankId: yup.string('rank must be selected'),
        characterClassId: yup.string('character class must be selected'),
        passiveIds: arrayValidator,
        traitIds: arrayValidator,
        strengthId: yup.number().positive('strength must be selected'),
        agilityId: yup.number().positive('agility must be selected'),
        vitalityId: yup.number().positive('vitality must be selected'),
    });
